import React from 'react';
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { FaArrowLeft } from "react-icons/fa";
import { LinkContainer } from 'react-router-bootstrap';

const CollegeDetailsHeader = (props) => {

    const { title, cover, category } = props;

    const history = useHistory();

    return (
        <div className="course-header page-header" style={{ backgroundImage: !!cover ? 'url(' + cover + ')' : 'none' }}>
            <Container className="pb-5">
                <Row className="position-relative mb-4">
                    <Col xs={1} className="align-self-center page-back-wrap">
                        <button className="btn btn-link text-white" onClick={() => history.goBack()}><FaArrowLeft /></button>
                    </Col>
                    <Col xs={11}>
                        <Breadcrumb className="breadcumb">
                            <Breadcrumb.Item>হোম</Breadcrumb.Item>
                            <LinkContainer to="/medical-colleges"><Breadcrumb.Item>কলেজসমূহ</Breadcrumb.Item></LinkContainer>
                            {category && <LinkContainer to={`/medical-colleges/${category.name}/${category._id}`}><Breadcrumb.Item>{category && category.name}</Breadcrumb.Item></LinkContainer>}
                            {/* <Breadcrumb.Item active>Data</Breadcrumb.Item> */}
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col className="align-self-center course-header-content" xs={12} md={12}>
                        <Row className="py-3">
                            <Col xs={12}>
                                {
                                    !!title && <h2 className="page-title">{title}</h2>
                                }
                            </Col>
                            <Col xs={12}>
                                {
                                    !!props.children && props.children
                                }
                            </Col>
                        </Row>
                    </Col>
                    {/* <Col xs={12} md={5} className="align-self-md-end text-md-right text-center">
                        {
                            !!cover && <Image className="img-fluid page-cover" src={cover} />
                        }
                    </Col> */}
                </Row>
            </Container>
        </div>
    )
}

export default CollegeDetailsHeader;